function getUrl(path) {
  return `//domainapi.aliyun.com/checkOnsale/${path}`;
}

export default class Service {

  constructor(feature) {
    this.feature = feature;
  }

  async search(keyWord, params = {}) {
    params.pageSize = params.pageSize || 5;
    params.currentPage = params.currentPage || 1;
    const url = getUrl('search');
    let result = await this.feature.request.send(url,
      { keyWord, ...params }, {
        loading: false,
        ignoreError: true
      });
    return result || [];
  }

}


// WEBPACK FOOTER //
// ./src/sale/service.js